module.exports = __webpack_public_path__ + "img/team_2.5a4253ff.png";